import { useQuery } from '@apollo/client';
import React from 'react';
import {
  StaffRole,
  StaffStaffSearchContainerStaffUsersSearchFieldsFragment,
  StaffStaffSearchFilterContainerStaffRolesDocument,
  StaffStaffSearchFilterContainerStaffUserGetAllTagsDocument
} from '../../../../generated';
import { ComponentQueryLoader } from '../../../shared/component-query-loader';
import { StaffSearchFilter } from './staff-search-filter';

interface StaffSearchFilterContainerProps {
  filterDataCount: StaffStaffSearchContainerStaffUsersSearchFieldsFragment;
  setRefreshQuery: React.Dispatch<React.SetStateAction<boolean>>;
}

export const StaffSearchFilterContainer: React.FC<StaffSearchFilterContainerProps> = (props) => {
  const refreshTagHandler = () => {
    refetchGetAllStaffTags();
    props?.setRefreshQuery(true);
  };

  const { data: roleList, error: roleListError, loading: roleListLoading } = useQuery(StaffStaffSearchFilterContainerStaffRolesDocument);

  const {
    data: getAllStaffTags,
    error: getAllStaffTagsError,
    loading: getAllStaffTagsLoading,
    refetch: refetchGetAllStaffTags
  } = useQuery(StaffStaffSearchFilterContainerStaffUserGetAllTagsDocument);

  return (
    <div className="min-w-[220px] max-w-[300px]">
      <ComponentQueryLoader
        loading={roleListLoading || getAllStaffTagsLoading}
        error={roleListError || getAllStaffTagsError}
        hasData={roleList && getAllStaffTags}
        hasDataComponent={
          <StaffSearchFilter
            roleList={roleList?.staffRoles as StaffRole[]}
            data={props.filterDataCount}
            allTags={getAllStaffTags?.staffUserGetAllTags as string[]}
            refreshTagHandler={refreshTagHandler}
          />
        }
      />
    </div>
  );
};
